import React, { useState } from 'react';
import {
  Stack,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Divider,
  Alert
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { setMask } from 'utils';

const ExternalChargeForm = ({ onSubmit, loading, totalDebtValue, pendingInstallmentsCount }) => {
  const [formData, setFormData] = useState({
    recoveryService: 'payhop',
    recoveryFee: 10,
    externalId: '',
    observation: ''
  });

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    onSubmit(formData);
  };

  return (
    <Stack direction="column" spacing={3} sx={{
      minWidth: { xs: '100%', sm: 400 },
      maxWidth: '100%'
    }}>
      <Typography variant="body2" color="text.secondary">
        Configure os parâmetros para enviar este contrato para cobrança externa.
      </Typography>

      <FormControl fullWidth>
        <InputLabel>Serviço de Recuperação</InputLabel>
        <Select
          value={formData.recoveryService}
          label="Serviço de Recuperação"
          onChange={(e) => handleChange('recoveryService', e.target.value)}
        >
          <MenuItem value="payhop">PayHop</MenuItem>
          <MenuItem value="manual">Manual</MenuItem>
        </Select>
      </FormControl>

      <TextField
        fullWidth
        label="Taxa de Recuperação (%)"
        type="number"
        value={formData.recoveryFee}
        onChange={(e) => handleChange('recoveryFee', Number(e.target.value))}
        inputProps={{ min: 0, max: 100, step: 0.1 }}
        helperText="Porcentagem da taxa de recuperação (ex: 10 para 10%)"
      />

      <TextField
        fullWidth
        label="ID Externo (Opcional)"
        value={formData.externalId}
        onChange={(e) => handleChange('externalId', e.target.value)}
        helperText="Identificador externo da cobrança (opcional)"
      />

      <TextField
        fullWidth
        label="Observação (Opcional)"
        multiline
        rows={3}
        value={formData.observation}
        onChange={(e) => handleChange('observation', e.target.value)}
        helperText="Observações adicionais sobre a cobrança externa"
      />

      {totalDebtValue && (
        <>
          <Divider sx={{ my: 2 }} />

          <Alert severity="info" sx={{ mb: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
              Resumo Financeiro
            </Typography>
            <Box sx={{ mt: 1 }}>
              <Typography variant="body2" color="text.secondary">
                <strong>Dívida Original:</strong> {setMask('money', totalDebtValue)}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                * Valor total com acréscimo de juros e multa por atraso.
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Parcelas pendentes:</strong> {pendingInstallmentsCount || 0}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Taxa de recuperação:</strong> {formData.recoveryFee}%
              </Typography>
              <Typography variant="body2" color="primary.main" sx={{ fontWeight: 'bold', mt: 1 }}>
                <strong>Valor a ser enviado:</strong> {setMask('money', totalDebtValue + (totalDebtValue * formData.recoveryFee / 100))}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                * Valor calculado com base na taxa de recuperação e dívida original.
              </Typography>
            </Box>
          </Alert>
        </>
      )}

      <Stack direction="row" spacing={2} justifyContent="flex-end">
        <LoadingButton
          variant="contained"
          onClick={handleSubmit}
          loading={loading}
          disabled={!formData.recoveryService || formData.recoveryFee < 0 || formData.recoveryFee > 100}
        >
          Criar Cobrança Externa
        </LoadingButton>
      </Stack>
    </Stack>
  );
};

export default ExternalChargeForm;